// extracted by mini-css-extract-plugin
export default {"wrapper":"defaultlayout_wrapper__algjX","body":"defaultlayout_body__s0uNe"};